import { Component, OnInit } from "@angular/core";
import { AppService }        from "../../../services/app.service";
import { StatusListener }    from "../../../status-listener";

@Component({
	selector: "app-tur-served",
	templateUrl: "./tur-served.component.html",
	styleUrls: ["./tur-served.component.scss"]
})
export class TurServedComponent extends StatusListener implements OnInit {

	theme = "tur";

	constructor(protected app: AppService) {
		super(app);
	}

	async ngOnInit() {
		/* VERALTET
		this.navigator.setDoNotNavigate(true);
		await this.api.cartApi.clear();
		await this.api.orderApi.cancel(true);
		setTimeout(() => {
			this.navigator.setDoNotNavigate(false);
			this.navigator.openPageAndReportUserActivity(`/${this.theme}/menu`);
		}, 5000);
		*/
	}

}
